/* External */
import { useIntl } from 'react-intl';

/* Ott-common */
import { Errors } from '@dtvgo/player-utils';

/* Hooks */
import usePlural from '../../hooks/usePlural';

const sourceErrorMessages = {
  title: 'player.error.source.title',
  subtitle: 'player.error.description',
};

const ERROR_MESSAGES = {
  [Errors.ErrorCode.BLACKOUT]: {
    title: 'common.weAreSorry',
    subtitle: 'epg.detail.blackout.subtitle',
    button: 'common.accept',
  },
  [Errors.ErrorCode.NOT_IN_PACKAGE]: {
    subtitle: 'player.error.entitlements.title',
  },
  [Errors.ErrorCode.CONCURRENCY_PER_USER]: {
    title: 'player.error.deviceLimitTitle',
    subtitle: 'player.error.deviceLimitDescription',
  },
  [Errors.ErrorCode.CONCURRENCY_PER_CHANNEL]: {
    title: 'player.error.channelLimitTitle',
    subtitle: 'player.error.channelLimitDescription',
  },
  [Errors.ErrorCode.CONCURRENCY_PER_DEVICE]: {
    title: 'player.error.stationLimitTitle',
    subtitle: 'player.error.stationLimitDescription',
  },
  [Errors.ErrorCode.CONCURRENCY_PER_PROVIDER]: {
    title: 'player.error.concurrency.provider.title',
    subtitle: 'player.error.concurrency.provider.description',
  },
  [Errors.ErrorCode.REFRESH_TOKEN_REVOKED]: {
    title: 'player.error.refreshTokenRevoked.title',
    subtitle: 'player.error.refreshTokenRevoked.description',
    button: 'profile.error.ok',
  },
  [Errors.AuthorizerErrorCode.GOOGLE_PLAY_NOT_IN_PACKAGE]: {
    title: 'player.error.entitlementsGooglePlay.title',
    subtitle: 'player.error.entitlementsGooglePlay.subtitle',
    button: 'profile.error.ok',
  },
};

export function useErrorMessages(error, contentTitle) {
  const { formatMessage } = useIntl();

  // TODO: Fix this logic: The code should be unique, so GOOGLE_PLAY_NOT_IN_PACKAGE
  // should have its own on Errors.ErrorCode enum
  const details = error?.data?.response?.data?.details;
  const errorCode = error.code === Errors.ErrorCode.NOT_IN_PACKAGE && details
    === Errors.AuthorizerErrorCode.GOOGLE_PLAY_NOT_IN_PACKAGE ? details : error.code;

  let translations = ERROR_MESSAGES[errorCode];
  if (!translations && error.isSourceError) translations = sourceErrorMessages;

  const csmLimit = error.data?.response?.data?.csm || 2;
  const pluralizedPeople = usePlural({ number: csmLimit, translations: { singular: 'common.person', plural: 'common.people' } });
  const values = { contentTitle, csmLimit, pluralizedPeople };

  if (translations) {
    return {
      title: translations.title
        && formatMessage({ id: translations.title }, values),
      subtitle: translations.subtitle
        && formatMessage({ id: translations.subtitle }, values),
      button: translations.button
        && formatMessage({ id: translations.button }, values),
    };
  }

  return {
    title: '',
    subtitle: formatMessage({ id: 'player.error.title' }, values),
  };
}
